// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__IcD0c","emails":"CreateEditClinics_emails__2JQmO","emailTagLabel":"CreateEditClinics_emailTagLabel__1KDMx"};